import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-leeds-trinity',
  templateUrl: './leeds-trinity.component.html',
  styleUrls: ['./leeds-trinity.component.scss']
})
export class LeedsTrinityComponent {
    fullName: string;
    email: any;
    date: any;
    emailComponent= '@'
    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<LeedsTrinityComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
      ) { }
      ngOnInit(): void {
        if(this.data){
          this.fullName = `${this.data.firstName} ${this.data.lastName}`.toUpperCase();
          this.email = this.data.email;
          this.date = this.data.date;
        }
      }
      close(val?: any) {
        this.dialogRef.close(val);
      }
      sendForSignature() {
        this.dialogRef.close('sendForSignature');
    }
}

